/**
 *
 * Widgets
 *
 */

import { Divider, Popover } from "antd"
import {
  ExclamationCircleFilled,
  QuestionCircleFilled,
  StarFilled,
} from "@ant-design/icons"
import React, { Fragment } from "react"

import { HISTORICAL_ANALYSIS } from "../../utils/constants"
import PropTypes from "prop-types"
import WidgetDetailsResponse from "../WidgetDetailsResponse"
import WidgetEnps from "../WidgetEnps"
import WidgetList from "../WidgetList"
import WidgetOutcomeOld from "../WidgetOutcomeOld"
import WidgetResponseRate from "../WidgetResponseRate"
import WidgetResumen from "../WidgetResumen"
import { get } from "lodash"
import { isModuleBySlug } from "../../utils/storage"
import "./index.less"

/* eslint-disable react/prefer-stateless-function */
class Widgets extends React.Component {
  state = {
    showHistoryWidget: false,
    showRestHistoryWidget: true,
  }

  changeStatusHistoryWidget = () => {
    const isHistoricalAnalysis = isModuleBySlug(HISTORICAL_ANALYSIS)
    const { showHistoryWidget } = this.state
    if (!isHistoricalAnalysis) {
      this.setState({ showHistoryWidget: false })
    }
    this.setState({ showHistoryWidget: !showHistoryWidget })
  }

  contentEngagement = () => {
    const style = {
      margin: "5px -16px",
      textAlign: "justify",
      width: "calc(100% + 32px)",
    }

    return (
      <Fragment>
        <b>Engagement</b>
        <Popover
          title="Engagement"
          placement="bottomRight"
          content={
            <div style={{ maxWidth: 360 }}>
              <p>
                El <b>Engagement</b> representa el nivel de compromiso y
                entusiasmo de los colaboradores con la organización. Se calcula
                en base a las siguientes 5 preguntas:
              </p>
              <Divider style={style} />
              <p>
                <b style={{ color: "#878787" }}>Recomendación (eNPS):</b>
                <br />
                Recomendaría esta organización como lugar de trabajo a mis
                amigos o familiares.
              </p>
              <Divider style={style} />
              <p>
                <b style={{ color: "#878787" }}>Motivación:</b>
                <br />
                La organización me motiva a hacer más de lo que exige mi puesto.
              </p>
              <Divider style={style} />
              <p>
                <b style={{ color: "#878787" }}>Compromiso:</b>
                <br />
                Me siento comprometido con la organización y su propósito.
              </p>
              <Divider style={style} />
              <p>
                <b style={{ color: "#878787" }}>Lealtad:</b>
                <br />
                Tengo la intención de trabajar en la organización por los
                próximos dos años.
              </p>
              <Divider style={style} />
              <p style={{ marginBottom: 0 }}>
                <b style={{ color: "#878787" }}>Orgullo:</b>
                <br />
                Me siento orgulloso de trabajar en esta organización.
              </p>
            </div>
          }>
          <QuestionCircleFilled
            style={{
              color: "#D8D8D8",
              verticalAlign: "baseline",
              fontSize: "14px",
              marginLeft: 8,
            }}
          />
        </Popover>
      </Fragment>
    )
  }

  renderByType = (type) => {
    const { data, isLoading, view_leader, metricsLabel } = this.props
    const { showHistoryWidget } = this.state

    switch (type) {
      case 1: // leadership
        return (
          <div
            className="ReportHome-widgets"
            style={
              showHistoryWidget ? { gridTemplateColumns: "3.8fr 1fr" } : null
            }>
            <WidgetResumen
              showEvolution={this.changeStatusHistoryWidget}
              hasEvolution={data.has_comparative}
              typeReport={data.survey.id_survey_type}
              dataHistory={data.evolution_measure}
              showHistoryWidget={showHistoryWidget}
              className="WidgetResumenComponent boxShadow"
              isLoading={isLoading}
              data={data.measure_climate}
              widthContainer="26%"
              widthContainerPeakons="74%"
              hasLeader={view_leader}
              title={
                <Fragment>
                  <b>{view_leader ? "Liderazgo" : metricsLabel}</b>
                </Fragment>
              }
              withEmpty
            />
            <WidgetResponseRate
              isLoading={isLoading}
              data={data.measure_climate}
              dataRate={data.measure}
            />
            {!showHistoryWidget && (
              <Fragment>
                <WidgetList
                  measure={data.measure}
                  isLoading={isLoading}
                  data={data.dimensions_top}
                  title="Mejores Dimensiones"
                  icon={
                    <StarFilled
                      style={{ fontSize: "14px", color: "#FBD668" }}
                    />
                  }
                />
                <WidgetList
                  measure={data.measure}
                  isLoading={isLoading}
                  data={data.dimensions_bottom}
                  title="Mayores oportunidades de mejora"
                  icon={
                    <ExclamationCircleFilled
                      style={{ fontSize: "14px", color: "#E37879" }}
                    />
                  }
                />
              </Fragment>
            )}
          </div>
        )

      case 2:
        return (
          <div
            className="ReportHome-widgets"
            style={
              !showHistoryWidget
                ? { gridTemplateColumns: "4.7fr 1.7fr", display: "grid" }
                : { gridTemplateColumns: "1fr", display: "grid" }
            }>
            {showHistoryWidget ? (
              <div
                className="ReportHome-widgets-groups-block"
                style={{ gridTemplateRows: "none" }}>
                <WidgetResumen
                  showEvolution={this.changeStatusHistoryWidget}
                  showHistoryWidget={showHistoryWidget}
                  title={this.contentEngagement()}
                  isEngagement
                  isLoading={isLoading}
                  data={data.measure_engagement}
                  dataHistory={data.evolution_measure}
                  typeReport={data.survey.id_survey_type}
                  className="boxShadow "
                  widthContainer="22%"
                  widthContainerPeakons="78%"
                />
              </div>
            ) : (
              <Fragment>
                <div
                  className="boxShadow ReportHome-widgets-groups"
                  style={{
                    gridTemplateColumns: "1fr 1fr 1fr",
                    display: "grid",
                  }}>
                  <div className="ReportHome-widgets-groups-block">
                    <WidgetResumen
                      showEvolution={this.changeStatusHistoryWidget}
                      showHistoryWidget={showHistoryWidget}
                      title={this.contentEngagement()}
                      isEngagement
                      isLoading={isLoading}
                      data={data.measure_engagement}
                      dataHistory={data.evolution_measure}
                      typeReport={data.survey.id_survey_type}
                      className="none "
                    />
                  </div>
                  <Fragment>
                    <div className="ReportHome-widgets-groups-block">
                      <WidgetEnps data={data.enps} />
                    </div>
                    <div className="ReportHome-widgets-groups-block">
                      <WidgetOutcomeOld
                        showTitle
                        data={data.dimensions_outcomes}
                      />
                    </div>
                  </Fragment>
                </div>
                <WidgetResponseRate
                  isLoading={isLoading}
                  data={data.measure_engagement}
                  dataRate={data.measure}
                />
              </Fragment>
            )}
          </div>
        )

      case 3:
        return (
          <div
            className="ReportHome-widgets"
            style={
              !showHistoryWidget
                ? { gridTemplateColumns: "3fr 1.55fr 1.7fr" }
                : { gridTemplateColumns: "1fr" }
            }>
            {showHistoryWidget ? (
              <div
                className="ReportHome-widgets-groups-block"
                style={{ gridTemplateRows: "none" }}>
                <WidgetResumen
                  showEvolution={this.changeStatusHistoryWidget}
                  showHistoryWidget={showHistoryWidget}
                  title={this.contentEngagement()}
                  isEngagement
                  isLoading={isLoading}
                  data={data.measure_engagement}
                  dataHistory={data.evolution_measure}
                  typeReport={data.survey.id_survey_type}
                  className="boxShadow "
                  widthContainer="22%"
                  widthContainerPeakons="78%"
                />
              </div>
            ) : (
              <Fragment>
                <div
                  className="boxShadow ReportHome-widgets-groups"
                  style={{ gridTemplateColumns: "1fr 1fr" }}>
                  <div className="ReportHome-widgets-groups-block">
                    <WidgetResumen
                      showEvolution={this.changeStatusHistoryWidget}
                      showHistoryWidget={showHistoryWidget}
                      title={this.contentEngagement()}
                      isEngagement
                      isLoading={isLoading}
                      data={data.measure_engagement}
                      dataHistory={data.evolution_measure}
                      typeReport={data.survey.id_survey_type}
                      className=" "
                      widthContainer="22%"
                      widthContainerPeakons="78%"
                    />
                  </div>
                  <div className="ReportHome-widgets-groups-block">
                    <WidgetOutcomeOld
                      showTitle
                      data={data.dimensions_outcomes}
                    />
                  </div>
                </div>
                <div className="WidgetResumenComponent boxShadow">
                  <WidgetEnps data={data.enps} />
                </div>
                <WidgetResponseRate
                  isLoading={isLoading}
                  data={data.measure_engagement}
                  dataRate={data.measure}
                />
              </Fragment>
            )}
          </div>
        )

      case 4:
        return (
          <div
            className="ReportHome-widgets"
            style={{
              minHeight: 220,
              gridTemplateColumns: this.props.historyMeasure
                ? "4.65fr 1.65fr 1.7fr"
                : "4.65fr 2fr",
            }}>
            <div
              className="boxShadow ReportHome-widgets-groups"
              style={{ gridTemplateColumns: "1fr 1fr" }}>
              <div className="ReportHome-widgets-groups-block">
                <WidgetResumen
                  showEvolution={this.changeStatusHistoryWidget}
                  showHistoryWidget={showHistoryWidget}
                  title={this.contentEngagement()}
                  isEngagement
                  isLoading={isLoading}
                  data={data.measure_engagement}
                  dataHistory={data.evolution_measure}
                  typeReport={data.survey.id_survey_type}
                  className=" "
                  widthContainer="22%"
                  widthContainerPeakons="78%"
                />
              </div>
              <div className="ReportHome-widgets-groups-block">
                <WidgetOutcomeOld showTitle data={data.dimensions_outcomes} />
              </div>
            </div>
            {this.props.historyMeasure ? (
              <Fragment>
                <WidgetResumen
                  showEvolution={this.changeStatusHistoryWidget}
                  hasEvolution={data.has_comparative}
                  typeReport={data.survey.id_survey_type}
                  dataHistory={data.evolution_measure}
                  showHistoryWidget={showHistoryWidget}
                  className="WidgetResumenComponent boxShadow"
                  isLoading={isLoading}
                  data={data.measure_climate}
                  widthContainer="26%"
                  widthContainerPeakons="74%"
                  hasLeader={view_leader}
                  title={
                    <Fragment>
                      <b>{view_leader ? "Liderazgo" : "Clima laboral"}</b>
                    </Fragment>
                  }
                />
                <div>
                  <WidgetResponseRate
                    isLoading={isLoading}
                    data={data.measure_engagement}
                    dataRate={data.measure}
                  />
                  <WidgetDetailsResponse
                    small
                    isLoading={this.props.isLoading}
                    responseTime={get(this.props, "data", {})}
                  />
                </div>
              </Fragment>
            ) : (
              <WidgetResponseRate
                isLoading={isLoading}
                data={data.measure_engagement}
                dataRate={data.measure}
              />
            )}
          </div>
        )

      case 5:
        return (
          <div
            className="ReportHome-widgets"
            style={{ gridTemplateColumns: "4.65fr 1fr 1.7fr" }}>
            <div
              className="boxShadow ReportHome-widgets-groups"
              style={{ gridTemplateColumns: "1fr 1fr" }}>
              <div className="ReportHome-widgets-groups-block">
                <WidgetResumen
                  showEvolution={this.changeStatusHistoryWidget}
                  showHistoryWidget={showHistoryWidget}
                  title={this.contentEngagement()}
                  isLoading={isLoading}
                  data={data.measure_engagement}
                  dataHistory={data.evolution_measure}
                  typeReport={data.survey.id_survey_type}
                  className=" "
                  widthContainer="22%"
                  widthContainerPeakons="78%"
                />
              </div>
              <div className="ReportHome-widgets-groups-block">
                <WidgetOutcomeOld showTitle data={data.dimensions_outcomes} />
              </div>
            </div>
            <div className="WidgetResumenComponent boxShadow">
              <WidgetResumen
                showEvolution={this.changeStatusHistoryWidget}
                hasEvolution={data.has_comparative}
                typeReport={data.survey.id_survey_type}
                dataHistory={data.evolution_measure}
                showHistoryWidget={showHistoryWidget}
                className="WidgetResumenComponent"
                isLoading={isLoading}
                data={data.measure_climate}
                widthContainer="26%"
                widthContainerPeakons="74%"
                hasLeader={view_leader}
                title={
                  <Fragment>
                    <b>{view_leader ? "Liderazgo" : "Clima laboral"}</b>
                  </Fragment>
                }
              />
            </div>
            <WidgetResponseRate
              isLoading={isLoading}
              data={data.measure_engagement}
              dataRate={data.measure}
            />
          </div>
        )
    }
  }

  render() {
    let type
    const {
      data: { survey = {}, enps = {} },
    } = this.props

    if (this.props.isLoading) return null

    switch (survey.engagement) {
      case true:
        if (enps && enps.questions_count) {
          if (enps.engagement) {
            type = 2
          } else {
            type = 3
          }
        } else {
          type = 4
        }
        break

      case false: // liderazgo
        if (this.props.historyMeasure) {
          type = 5 // liderazgo con widget history
        } else {
          type = 1 // liderazgo normal
        }
        break
    }

    return this.renderByType(type)
  }
}

Widgets.propTypes = {
  metricsLabel: PropTypes.string,
}

export default Widgets
